import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { LayoutContext } from 'components/app-routes';
import './index.css';
import { getAgentCode, getUserDetails } from '__utils/storage';
import MobileFooterLayout from 'components/old-footer-layout';
import CustomTabs from 'components/custom-tabs';
import { PROFILE_TABS } from './constants';
import { INDIVIDUAL_TAX_STATUS } from 'constants/common-constants';
import NonIndiVidualProfileView from './non-individual-profile';
import { getQueryParamsFromString } from '__utils/common-utils';
import ProfileMobileSection from './profile-mobile-section';
import { MY_PROFILE_HEADER } from 'constants/header-titles';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import elementVisibility from '__utils/toggleVisibilty-util';

const ProfileDetails = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { SetLayoutProps } = React.useContext(LayoutContext);
    const { isDP } = getQueryParamsFromString(window?.location?.search);

    useEffect(() => {
        SetLayoutProps({
            config: { title: MY_PROFILE_HEADER }
        });
        Mixpanel.track(getEventName("isDP", "loaded", "profile"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isDP: isDP == 'false' ? false : true
        });
        !getUserDetails() && elementVisibility.show('loginDiv');
    }, [])

    return (
        <div className='profile-wrapper'>
            {
                (getUserDetails()?.taxStatus && getUserDetails()?.taxStatus !== INDIVIDUAL_TAX_STATUS) ? <NonIndiVidualProfileView /> :
                    (isMobile ? <ProfileMobileSection /> :
                        <CustomTabs defaultActiveKey='1' tabItems={PROFILE_TABS}></CustomTabs>)
            }

            <MobileFooterLayout />
        </div>
    )
}

export default ProfileDetails
